import { useCallback, useEffect, useState } from "react";
import { supabase } from "@/integrations/supabase/client";

export interface SafeVenue {
  id: string;
  name: string;
  category: string;
  city: string | null;
  country: string | null;
  lat: number;
  lng: number;
  why_safe: string | null;
  hours: string | null;
  url: string | null;
}

export const SAFE_VENUE_CATEGORY_LABELS: Record<string, string> = {
  cafe: "Café",
  bar_no_alcohol: "Bar (alcohol-free)",
  library: "Library",
  park: "Park",
  hotel_lobby: "Hotel lobby",
  community_center: "Community center",
};

export function useSafeVenues(opts: { city?: string | null; near?: { lat: number; lng: number } | null } = {}) {
  const { city, near } = opts;
  const [venues, setVenues] = useState<SafeVenue[]>([]);
  const [loading, setLoading] = useState(true);

  const refresh = useCallback(async () => {
    let q = supabase.from("safe_venues").select("*").eq("active", true).limit(40);
    if (city) q = q.eq("city", city);
    const { data } = await q;
    let list = (data ?? []) as SafeVenue[];
    if (near && list.length > 0) {
      const { lat, lng } = near;
      list = [...list].sort((a, b) => {
        const da = (a.lat - lat) ** 2 + (a.lng - lng) ** 2;
        const db = (b.lat - lat) ** 2 + (b.lng - lng) ** 2;
        return da - db;
      });
    }
    setVenues(list);
    setLoading(false);
  }, [city, near?.lat, near?.lng]); // eslint-disable-line react-hooks/exhaustive-deps

  useEffect(() => {
    void refresh();
  }, [refresh]);

  return { venues, loading, refresh };
}
